import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocalStorageEnum } from 'src/app/models/enums/local-storage.enum';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Pipe({
  name: 'staticERPLFile'
})
export class StaticERPLFilePipe implements PipeTransform {
  constructor(private localStorageService: LocalStorageService) {}

  transform(value: string, type: 'streaming' | 'download' | 'streaming_auth' | 'download_auth' = 'download'): string {
    if (value && type === 'download') {
      return environment.file_static_erpl_url + value;
    }
    if (value && type === 'streaming_auth') {
      const auth_token = `${this.localStorageService.get(LocalStorageEnum.token)}`;
      return environment.api_url + '/admin/statistic_document/streaming/' + value + '?auth_token=' + auth_token;
    }
    return null;
  }
}
